import React from 'react';

const StatCard = ({
  label,
  value,
  icon: Icon,
  gradient = null,
  iconBg = 'bg-primary-100 dark:bg-primary-900/30',
  iconColor = 'text-primary-600 dark:text-primary-400',
  valueColor = 'text-gray-900 dark:text-white',
  className = '',
}) => {
  if (gradient) {
    return (
      <div className={`rounded-2xl p-5 shadow-card bg-gradient-to-br ${gradient} ${className}`}>
        <div className="flex items-center gap-3">
          {Icon && (
            <div className="p-2.5 bg-white/20 rounded-xl">
              <Icon className="w-5 h-5 text-white" />
            </div>
          )}
          <div>
            <p className="text-sm text-white/80">{label}</p>
            <p className="text-2xl font-bold text-white mt-0.5">{value}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-white dark:bg-dark-800 rounded-2xl p-5 shadow-card border border-gray-100 dark:border-dark-700 ${className}`}>
      <div className="flex items-center gap-3">
        {Icon && (
          <div className={`p-2.5 rounded-xl ${iconBg}`}>
            <Icon className={`w-5 h-5 ${iconColor}`} />
          </div>
        )}
        <div>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">{label}</p>
          <p className={`text-2xl font-bold mt-0.5 ${valueColor}`}>{value}</p>
        </div>
      </div>
    </div>
  );
};

export const StatGrid = ({ children, cols = 'grid-cols-2 md:grid-cols-4', className = '' }) => (
  <div className={`grid ${cols} gap-4 ${className}`}>{children}</div>
);

export default StatCard;
